import { motion } from "framer-motion";
import { HOW_WE_WORK_STEPS } from "@/data/content";

export const HowWeWork = () => (
  <section data-testid="how-we-work-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[40px] lg:px-12 lg:py-[80px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <h2
          data-testid="how-we-work-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          One team around
          <br className="sm:hidden" /> the project
        </h2>
        <p data-testid="how-we-work-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
          Complex energy projects require more than equipment. They require coordination across
          engineering, suppliers, contractors, permitting, commissioning and long-term operation.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        data-testid="how-we-work-sequence"
        className="mt-[46px] grid grid-cols-1 gap-10 sm:grid-cols-3 lg:mt-16 lg:grid-cols-5 lg:gap-8"
      >
        {HOW_WE_WORK_STEPS.map((step, i) => (
          <div
            key={step.title}
            data-testid={`how-we-work-step-${i}`}
            className="border-t border-borderLight pt-6"
          >
            <span className="font-mono text-xs font-medium text-teal">{String(i + 1).padStart(2, "0")}</span>
            <span className="mt-3 block font-heading text-xl font-semibold text-ink lg:text-2xl">
              {step.title}
            </span>
            <p className="mt-2 text-sm leading-relaxed text-inkSoft">
              {step.title === "Deliver" ? (
                <>
                  Manage integration, installation coordination
                  <br className="sm:hidden" /> and commissioning.
                </>
              ) : step.title === "Coordinate" ? (
                <>
                  Bring together qualified suppliers, professionals
                  <br className="sm:hidden" /> and contractors.
                </>
              ) : (
                step.body
              )}
            </p>
          </div>
        ))}
      </motion.div>
    </div>
  </section>
);
